import React from 'react';
import './style.scss';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';
import Item from './Item';

const PromotionListComponent = (props) => {
  // In case the BE didn't provide appropriate data we'll render a dummy placeholder
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="PromotionListComponent" />;
  }

  const { fields } = props;
  const { imageAlignment } = props?.params;
  const promoList = fields?.promotionList;

  const shouldRenderPromoList = Array.isArray(promoList) && promoList?.length > 0;
  if (!shouldRenderPromoList) {
    return null;
  }
  return (
    <div className="PromotionListComponent">
      <div
        className={clsx(
          'content',
          'add-margins',
          props?.params?.Styles,
          imageAlignment?.toLowerCase()?.replace(/\s/g, '-') // right aligned or left aligned
        )}
      >
        <div className="items">
          {promoList?.map((item, index) => {
            return <Item key={index} props={props} item={item} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PromotionListComponent);
